import React from 'react';

import { LabeledValue } from 'antd/lib/select';
import Select from 'formik-antd/lib/select';
import { SelectProps } from 'formik-antd/lib/select';

const { Option, OptGroup } = Select;

export type LabelOptions = {
  label: string;
  options: LabeledValue[];
};

interface CustodianSelectProps extends SelectProps {
  custodians: LabelOptions[];
}

export default function CustodianSelect({
  custodians,
  ...selectProps
}: CustodianSelectProps) {
  const custodianOptions = () =>
    custodians.map(
      (optGroup: LabelOptions) =>
        optGroup.options?.length > 0 && (
          <OptGroup key={`${optGroup.label}Group`} label={optGroup.label}>
            {optGroup.options.map((option: LabeledValue) => (
              <Option key={option.key} value={option.value}>
                {option.label}
              </Option>
            ))}
          </OptGroup>
        )
    );

  return (
    <Select
      showSearch
      filterOption={(inputValue, option) => {
        return option?.props?.children
          ?.toString()
          .toLowerCase()
          .includes(inputValue.toLowerCase());
      }}
      {...selectProps}
    >
      {custodianOptions()}
    </Select>
  );
}
